module.exports = __webpack_public_path__ + "img/jypjgs_1.63fabff7.png";